import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Container, Row, Col, Table, Button, Modal, ButtonGroup, Card } from 'react-bootstrap';
import { BiListOl, BiRefresh,BiDownload } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';

const Bedah = () => {
    const [listBedah, setlistBedah] = useState([]);
    const [selectedBedah, setselectedBedah] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [showDeskripsi, setshowDeskripsi] = useState();
    const handleCloseDeskripsi = () => setshowDeskripsi(false);

    const loadInit = async () => {
        setIsLoading(true)
        try {
            const response = await VedikaService.getLabBedah(`noregistrasifk=${$('#noRegistrasi').text()}`);
            setlistBedah(response.data.data);
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        }finally{
            setIsLoading(false)
        }
    }
    const handleShowDeskripsi = (row) => {
        setshowDeskripsi(true);
        setselectedBedah(row)
    }

    const loadDtBedah = () => {
        $('#dtBedah').DataTable({
            data: listBedah,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy:true,
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: null,
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<div className='d-flex justify-content-center'><ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Deskripsi' onClick={() => handleShowDeskripsi(rowData)}><BiListOl /></Button></ButtonGroup></div>),
                },
                {
                    targets: [1],
                    data: 'tglbedah',
                },
                {
                    targets: [2],
                    data: 'noemr',
                },
                {
                    targets: [3],
                    data: 'namaruangan',
                },
            ]
        })
    }

    useEffect(()=>{
        loadDtBedah();
    },[listBedah])
    
    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 1000);
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Bedah</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-warning'>
                    <div className="d-flex flex-row-reverse align-items-center bd-highlight">
                        <a href={`https://pelayanan.rsabhk.co.id/vedika/cetak/bedah/${$('#norec').val()}`} style={{ textDecoration: 'none',color:'black' }} target='_blank' download><BiDownload /> Download </a>
                    </div>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive="sm" size="sm" id='dtBedah' bordered hover style={{ fontSize: 'smaller' }}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Tanggal Bedah</th>
                                <th>No EMR</th>
                                <th>Ruangan</th>
                            </tr>
                        </thead>
                    </Table>
                </Col>
            </Row>
            <Modal
                show={showDeskripsi}
                onHide={handleCloseDeskripsi}
                backdrop="static"
                size='xl'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Deskripsi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={2}>
                            {
                                selectedBedah ? (
                                    <Row>
                                        <Col sm={12}>
                                            <p className='f7'><strong>Anestesiologis</strong><br />{selectedBedah.anestesiologis ? selectedBedah.anestesiologis : '-'}</p>
                                        </Col>
                                        <Col sm={12}>
                                            <p className='f7'><strong>Penata Anestesi</strong><br />{selectedBedah.penataanestesi ? selectedBedah.penataanestesi : '-'}</p>
                                        </Col>
                                        <Col sm={12}>
                                            <p className='f7'><strong>Perawat Instrumen</strong><br />{selectedBedah.perawatinst ? selectedBedah.perawatinst : '-'}</p>
                                        </Col>
                                        <Col sm={12}>
                                            <p className='f7'><strong>Operator</strong><br />{selectedBedah.namaoperator ? selectedBedah.namaoperator : '-'}</p>
                                        </Col>
                                        <Col sm={12}>
                                            <p className='f7'><strong>Asisten Operator</strong><br />{selectedBedah.asistenoperator ? selectedBedah.asistenoperator : '-'}</p>
                                        </Col>
                                        <Col sm={12}>
                                            <p className='f7'><strong>Tanggal Pembedahan</strong><br />{selectedBedah.tglbedah ? selectedBedah.tglbedah : '-'}</p>
                                        </Col>
                                        <Col sm={12}>
                                            <p className='f7' style={{ marginBottom: '0px' }}><strong>JAM(WIB)</strong></p>
                                            <Row>
                                                <Col>
                                                    <p className='f7'><strong>Mulai</strong><br />{selectedBedah.jammulai ? selectedBedah.jammulai : '-'}</p>
                                                </Col>
                                                <Col>
                                                    <p className='f7'><strong>Selesai</strong><br />{selectedBedah.jamselesai ? selectedBedah.jamselesai : '-'}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col sm={12}>
                                            <p className='f7'><strong>Lama Pembedahan</strong><br />{selectedBedah.lamabedah ? selectedBedah.lamabedah : '-'}</p>
                                        </Col>
                                        <Col sm={12}>
                                            <p className='f7'><strong>Jumlah Pendarahan</strong><br />{selectedBedah.jmlperdarahan ? selectedBedah.jmlperdarahan : '-'} ml</p>
                                        </Col>
                                        <Col sm={12}>
                                            <p className='f7'><strong>Label Pasien</strong><br />{selectedBedah.labelpasien ? selectedBedah.labelpasien : '-'}</p>
                                        </Col>
                                        <Col sm={12}>
                                            <p className='f7'><strong>Status</strong><br />{selectedBedah.status}</p>
                                        </Col>
                                        <Col sm={12}>
                                            <p className='f7'><strong>Kondisi Penanganan</strong><br />{selectedBedah.kondisipenanganan}</p>
                                        </Col>
                                    </Row>
                                ) : null
                            }
                        </Col>
                        <Col>
                            <Container>
                                {
                                    selectedBedah ? (
                                        <>
                                            <Row className='pt-2'>
                                                <Col md={6}>
                                                    <Card>
                                                        <Card.Body>
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <p className='f7'><strong>Komplikasi</strong><br />{selectedBedah.komplikasi}</p>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                    <Card className='mt-2'>
                                                        <Card.Body>
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <p className='f7'><strong>Macam Jaringan</strong><br />{selectedBedah.macamjaringan}</p>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                    <Card className='mt-2'>
                                                        <Card.Header>Tindakan Pembedahan</Card.Header>
                                                        <Card.Body>
                                                            <Row>
                                                                <Col md={2}><h4 className='text-center'><strong>I</strong></h4></Col>
                                                                <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedBedah.tindakanbedah1}</p></Col>
                                                            </Row>
                                                            <hr className="hr" />
                                                            <Row>
                                                                <Col md={2}><h4 className='text-center'><strong>II</strong></h4></Col>
                                                                <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedBedah.tindakanbedah2}</p></Col>
                                                            </Row>
                                                            <hr className="hr" />
                                                            <Row>
                                                                <Col md={2}><h4 className='text-center'><strong>III</strong></h4></Col>
                                                                <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedBedah.tindakanbedah3}</p></Col>
                                                            </Row>
                                                            <hr className="hr" />
                                                            <Row>
                                                                <Col md={2}><h4 className='text-center'><strong>IV</strong></h4></Col>
                                                                <Col md={10}><p style={{ marginBottom: '0px' }} className='f7'>{selectedBedah.tindakanbedah4}</p></Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                                <Col md={6}>
                                                    <Card>
                                                        <Card.Body>
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <p className='f7'><strong>Uraian Pembedahan-sesuai dengan Instruksi kerja</strong><br />{selectedBedah.uraianbedah}</p>
                                                                </Col>
                                                            </Row>
                                                            <hr className="hr" />
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <p className='f7'><strong>Jaringan Patologi</strong><br />{selectedBedah.jaringanpatologi}</p>
                                                                </Col>
                                                            </Row>
                                                            <hr className="hr" />
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <p className='f7'><strong>Diagnosa Pra Bedah</strong><br />{selectedBedah.diagnosaprabedah}</p>
                                                                </Col>
                                                            </Row>
                                                            <hr className="hr" />
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <p className='f7'><strong>Diagnosa Pasca Bedah</strong><br />{selectedBedah.diagnosapascabedah}</p>
                                                                </Col>
                                                            </Row>
                                                            <hr className="hr" />
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <p className='f7'><strong>Kesesuaian Diagnosa Pra dan Pasca Bedah</strong><br />{selectedBedah.kesesuiandiagnosa}</p>
                                                                </Col>
                                                            </Row>
                                                            <hr className="hr" />
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className='pt-2'>
                                                <Col md={12}>
                                                    <Card>
                                                        <Card.Header>Instruksi Pasca Bedah</Card.Header>
                                                        <Card.Body>
                                                            <Row>
                                                                <Col md={3}>
                                                                    <Card>
                                                                        <Card.Header>
                                                                            1. Periksa
                                                                        </Card.Header>
                                                                        <Card.Body>
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className='f7'><strong>Tekanan Darah Setiap</strong><br />{selectedBedah.tekanandarah}</p>
                                                                                </Col>
                                                                            </Row>
                                                                            <hr className="hr" />
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className='f7'><strong>Nadi Setiap</strong><br />{selectedBedah.nadi}</p>
                                                                                </Col>
                                                                            </Row>
                                                                            <hr className="hr" />
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className='f7'><strong>Nadi Setiap</strong><br />{selectedBedah.nadi}</p>
                                                                                </Col>
                                                                            </Row>
                                                                            <hr className="hr" />
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className='f7'><strong>Pernafasan Setiap</strong><br />{selectedBedah.pernafasan}</p>
                                                                                </Col>
                                                                            </Row>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </Col>
                                                                <Col md={3}>
                                                                    <Card>
                                                                        <Card.Header>
                                                                            2. Makan / Minum
                                                                        </Card.Header>
                                                                        <Card.Body>
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className='f7'><strong>Makan</strong><br />{selectedBedah.makan}</p>
                                                                                </Col>
                                                                            </Row>
                                                                            <hr className="hr" />
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className='f7'><strong>Minum</strong><br />{selectedBedah.minum}</p>
                                                                                </Col>
                                                                            </Row>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </Col>
                                                                <Col md={3}>
                                                                    <Card>
                                                                        <Card.Header>
                                                                            3. Infus
                                                                        </Card.Header>
                                                                        <Card.Body>
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className='f7'><strong>Macam</strong><br />{selectedBedah.infusmacam}</p>
                                                                                </Col>
                                                                            </Row>
                                                                            <hr className="hr" />
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className='f7'><strong>Jumlah</strong><br />{selectedBedah.infusjml}</p>
                                                                                </Col>
                                                                            </Row>
                                                                            <hr className="hr" />
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className='f7'><strong>Tetesan</strong><br />{selectedBedah.infustetesan}</p>
                                                                                </Col>
                                                                            </Row>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </Col>
                                                                <Col md={3}>
                                                                    <Card>
                                                                        <Card.Header>
                                                                            4. Obat - obat &Instruksi Khusus
                                                                        </Card.Header>
                                                                        <Card.Body>
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className='f7'><strong>Obat - Obat</strong><br />{selectedBedah.obat}</p>
                                                                                </Col>
                                                                            </Row>
                                                                            <hr className="hr" />
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className='f7'><strong>Instruksi Khusus</strong><br />{selectedBedah.instruksikhusus}</p>
                                                                                </Col>
                                                                            </Row>
                                                                        </Card.Body>
                                                                    </Card>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </>
                                    ) : null
                                }
                            </Container>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default Bedah;